export default {
  video: {
    has: false,
    url: '',
    title: '',
  },
}
